import React, { FC, useState } from "react";
import { Input, Modal, Row, Col } from "antd";
import _ from "lodash";

const AnalyticsVideoModal: FC<{ onClose: () => void }> = ({ onClose }) => {
  const [isModalVisible, setIsModalVisible] = useState<boolean>(true);

  const handleCancel = () => {
    setIsModalVisible(false);
    onClose && onClose();
  };
  const handleOk = () => {
    setIsModalVisible(false);
    onClose && onClose();
  };

  return (
    <Modal
      visible={isModalVisible}
      onOk={handleOk}
      onCancel={handleCancel}
      width="700px"
      className="preview-modal"
      footer={[]}
      destroyOnClose={true}
    >
      <img
        style={{ width: "100%", height: "100%" }}
        src={`/images/analytics-video.png`}
      />
    </Modal>
  );
};
export default AnalyticsVideoModal;
